// Boo Club Modal Functionality
class BooClubModal {
  constructor() {
    this.modal = null;
    this.overlay = null;
    this.closeBtn = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.modal = document.getElementById('booClubModal');
    
    if (!this.modal) {
      console.warn('Boo Club Modal not found');
      return;
    }

    this.overlay = this.modal.querySelector('.boo-club-modal-overlay');
    this.closeBtn = this.modal.querySelector('.boo-club-modal-close');

    // Bind event listeners
    this.bindEvents();
  }

  bindEvents() {
    // Find all buttons with the class
    const triggers = document.querySelectorAll('.club-modal-btn');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  open() {
    if (this.modal) {
      this.modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
      
      // Add slight delay for animation
      setTimeout(() => {
        this.modal.style.opacity = '1';
      }, 10);
    }
  }

  close() {
    if (this.modal) {
      this.modal.style.opacity = '0';
      
      setTimeout(() => {
        this.modal.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }
  }

  isOpen() {
    return this.modal && this.modal.style.display === 'block';
  }
}

// Initialize the modal
const booClubModal = new BooClubModal();
